import { Reducer } from "redux";
import { ITimestamp, create24Timestamps } from "../components/TimestampsSelector/timestamps";

export enum ValidationProcess {
    Unknown = -1,
    DayAhead = 0,
    IntraDay = 1,
    Ltcc = 2,
}

export enum LtccType {
    Unknown = -1,
    Merged = 0,
    PerTimestamp = 1,
}

export enum LtccMonthlyYearly {
    Unknown = -1,
    Monthly = 0,
    Yearly = 1,
}

export const SET_VALIDATION_PROCESS = "SET_VALIDATION_PROCESS";
export const SetValidationProcess = (process: ValidationProcess, blockedUpdate: boolean = false) => {
    return { type: SET_VALIDATION_PROCESS, process, blockedUpdate };
};

export const SET_BLOCKED_UPDATE = "SET_BLOCKED_UPDATE";
export const SetBlockedUpdate = (blockedUpdate: boolean) => {
    return { type: SET_BLOCKED_UPDATE, blockedUpdate };
};

export const SET_LTCC_TYPE = "SET_LTCC_TYPE";
export const SetLtccType = (ltccType: LtccType) => {
    return { type: SET_LTCC_TYPE, ltccType };
};

export const SET_LTCC_MONTHLY_YEARLY = "SET_LTCC_MONTHLY_YEARLY";
export const SetLtccMonthlyYearly = (ltccMonthlyYearly: LtccMonthlyYearly) => {
    return { type: SET_LTCC_MONTHLY_YEARLY, ltccMonthlyYearly };
};

export const SET_AVAILABLE_TIMESTAMPS_OR_SCENARIOS = "SET_AVAILABLE_TIMESTAMPS_OR_SCENARIOS";
export const SetAvailableTimestampsOrScenarios = (availableTimestampsOrScenarios: ITimestamp[]) => {
    return { type: SET_AVAILABLE_TIMESTAMPS_OR_SCENARIOS, availableTimestampsOrScenarios };
};

export interface ValidationProcessState {
    process: ValidationProcess;
    blockedUpdate: boolean;
    ltccType: LtccType,
    ltccMonthlyYearly: LtccMonthlyYearly,
    availableTimestampsOrScenarios: ITimestamp[];
}

export const initialState: ValidationProcessState = {
    process: ValidationProcess.DayAhead,
    blockedUpdate: false,
    ltccType: LtccType.Merged,
    ltccMonthlyYearly: LtccMonthlyYearly.Unknown,
    availableTimestampsOrScenarios: create24Timestamps(),
};

export const validationProcessReducer: Reducer<ValidationProcessState> = (
    state: ValidationProcessState = initialState,
    action: any
): ValidationProcessState => {
    switch (action.type) {
        case SET_VALIDATION_PROCESS:
            return { ...state, process: action.process, blockedUpdate: action.blockedUpdate, availableTimestampsOrScenarios: action.process === ValidationProcess.Ltcc ? [] : create24Timestamps() };
        case SET_BLOCKED_UPDATE:
            return { ...state, blockedUpdate: action.blockedUpdate };
        case SET_LTCC_TYPE:
            return { ...state, ltccType: action.ltccType };
        case SET_LTCC_MONTHLY_YEARLY:
            return { ...state, ltccMonthlyYearly: action.ltccMonthlyYearly };
        case SET_AVAILABLE_TIMESTAMPS_OR_SCENARIOS:
            return { ...state, availableTimestampsOrScenarios: action.availableTimestampsOrScenarios };
        default:
            return state;
    }
};
